import { FC, ReactNode, StrictMode, useMemo } from "react";
import { createRoot } from "react-dom/client";
import isPropValid from "@emotion/is-prop-valid";
import { StyleSheetManager } from "styled-components";
import { BrowserRouter, Route, Routes } from "react-router";
import Homepage from "./src/Pages/Homepage.tsx";
import Service from "./src/Pages/Service.tsx";
import { WalletAdapterNetwork } from "@solana/wallet-adapter-base";
import { ConnectionProvider, WalletProvider } from "@solana/wallet-adapter-react";
import { clusterApiUrl } from "@solana/web3.js";

const root = createRoot(document.getElementById("app") as HTMLElement);

export const WalletWrapper: FC<{ children: ReactNode }> = ({ children }) => {
    // The network can be set to 'devnet', 'testnet', or 'mainnet-beta'.
    const network = WalletAdapterNetwork.Devnet;

    const endpoint = useMemo(() => clusterApiUrl(network), [network]);

    return (
        <ConnectionProvider endpoint={endpoint}>
            <WalletProvider wallets={[]} autoConnect>
                {children}
            </WalletProvider>
        </ConnectionProvider>
    );
};

root.render(
    <StrictMode>
        <BrowserRouter>
            <StyleSheetManager shouldForwardProp={shouldForwardProp}>
                {" "}
                <WalletWrapper>
                    <Routes>
                        <Route path="/" element={<Homepage />} />
                        <Route path="/service/:mintAddress" element={<Service />} />
                    </Routes>
                </WalletWrapper>
            </StyleSheetManager>
        </BrowserRouter>
    </StrictMode>
);

// This implements the default behavior from styled-components v5
function shouldForwardProp(propName: string, target: any) {
    if (typeof target === "string") {
        // For HTML elements, forward the prop if it is a valid HTML attribute
        return isPropValid(propName);
    }
    // For other elements, forward all props
    return true;
}
